import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

/**
 * Wraps an admin-only route.
 * Props:
 *   allowedRoles  – string[]  (omit = any valid admin role is OK)
 *   children      – JSX to render when authorised
 */
export default function AdminProtectedRoute({ allowedRoles, children }) {
  const token = localStorage.getItem("adminToken");
  if (!token) return <Navigate to="/admin/login" replace />;

  try {
    const decoded = jwtDecode(token);
    // Token expiry check
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminRole");
      return <Navigate to="/admin/login" replace />;
    }
    // Role check
    if (allowedRoles && allowedRoles.length > 0) {
      if (!allowedRoles.includes(decoded.admin_role)) {
        return <Navigate to="/admin/dashboard" replace />;
      }
    }
    return children;
  } catch {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminRole");
    return <Navigate to="/admin/login" replace />;
  }
}
